<div class="mtm-file-download-control">
  <!-- Video with transcode options: show dropdown -->
  @if (showVideoDropdown) {
    <div
      ngbDropdown
      placement="top"
      [container]="isFullscreen ? null : 'body'"
      [class.is-fullscreen]="isFullscreen"
      #downloadDrop="ngbDropdown"
      class="mtm-file-download-dropdown"
      (click)="$event.stopImmediatePropagation()">
      <button
        type="button"
        ngbDropdownToggle
        class="viewer-controller-icon-btn download-icon"
        [class.active]="downloadDrop.isOpen()"
        aria-label="Download"
        aria-haspopup="true">
        <div *ngIf="displayType === 'icon'" class="download-icon-wrap">
          <svg
            *ngIf="
              fileDownloadInfo?.status != transferStatus.DOWNLOADING &&
              fileDownloadInfo?.state != transferStatus.WAITING
            "
            width="18"
            height="18"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g class="icon-g">
              <path
                d="M12.8643 12.8624H0.71875M10.8401 6.11483L6.79154 10.1634M6.79154 10.1634L2.74301 6.11483M6.79154 10.1634V0.716797"
                stroke="currentColor"
                stroke-width="1.43315"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </svg>
          <mtm-download-upload-progress-icon
            [isOnLoading]="
              fileDownloadInfo?.status === transferStatus.DOWNLOADING ||
              fileDownloadInfo?.state === transferStatus.WAITING
            "
            [widthInPixel]="iconSize"
            [iconColor]="iconColor">
          </mtm-download-upload-progress-icon>
        </div>
      </button>
      <div ngbDropdownMenu class="download-dropdown-menu">
        @for (opt of videoDownloadOptions; track opt.label + (opt.quality ?? '')) {
          @if (opt.type === 'gif') {
            <div class="download-dropdown-divider"></div>
          }
          <button
            type="button"
            ngbDropdownItem
            class="download-option-item"
            (click)="downloadWithQuality(opt, downloadDrop); $event.stopPropagation()">
            <span class="download-option-icon" [class.original]="opt.type === 'original'">
              @if (opt.type === 'gif') {
                <span class="option-icon-text">GIF</span>
              } @else if (opt.type === 'audio') {
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 18V6h2v12H6zM10 14V10h2v4h-2zM14 18v-6h2v6h-2zM18 14h-2v4h2v-4z" fill="currentColor" />
                </svg>
              } @else {
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g class="icon-g">
                    <path
                      d="M12.8643 12.8624H0.71875M10.8401 6.11483L6.79154 10.1634M6.79154 10.1634L2.74301 6.11483M6.79154 10.1634V0.716797"
                      stroke="currentColor"
                      stroke-width="1.43315"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </g>
                </svg>
              }
            </span>
            <span class="download-option-content">
              <span class="download-option-heading">
                <span class="download-option-label">{{ opt.label }}</span>
                @if (opt.badge) {
                  <span class="download-option-badge" [class.badge-4k]="opt.badge === '4K'">{{ opt.badge }}</span>
                }
              </span>
              @if (opt.detail) {
                <span class="download-option-detail">{{ opt.detail }}</span>
              }
            </span>
          </button>
        }
      </div>
    </div>
  } @else {
    <!-- Image / audio / other: direct download on click (same style as viewer-controller-icon-btn) -->
    @if (displayType === 'icon') {
      <button
        type="button"
        class="viewer-controller-icon-btn download-icon"
        aria-label="Download"
        (click)="$event.stopImmediatePropagation(); downloadFile()">
        <span class="download-icon-wrap">
          <svg
            *ngIf="
              fileDownloadInfo?.status != transferStatus.DOWNLOADING &&
              fileDownloadInfo?.state != transferStatus.WAITING
            "
            width="18"
            height="18"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g class="icon-g">
              <path
                d="M12.8643 12.8624H0.71875M10.8401 6.11483L6.79154 10.1634M6.79154 10.1634L2.74301 6.11483M6.79154 10.1634V0.716797"
                stroke="currentColor"
                stroke-width="1.43315"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </svg>
          <mtm-download-upload-progress-icon
            [isOnLoading]="
              fileDownloadInfo?.status === transferStatus.DOWNLOADING ||
              fileDownloadInfo?.state === transferStatus.WAITING
            "
            [widthInPixel]="iconSize"
            [iconColor]="iconColor">
          </mtm-download-upload-progress-icon>
        </span>
      </button>
    } @else if (displayType === 'unknown-download') {
      <button
        type="button"
        class="viewer-controller-fit-btn btn-unknown-download"
        (click)="$event.stopImmediatePropagation(); downloadFile()">
        <img src="/assets/img/versioning/unknown-file-download.svg" alt="Download" width="22" height="22" />
        <span class="text-uppercase">{{ 'mediaPlayer_downloadFile' | translate }}</span>
      </button>
    }
  }
</div>
